import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router'

import LgyLink from 'app/components/util/lgy-link/LgyLink'
import AssignmentsList from '../components/AssignmentsList'
import PendingAssignmentsList from '../components/PendingAssignmentsList'

const RenderAssignmentLists = ({ workspace, location, appraiserInfo, unacceptedAssignments, canceledAssignments72Hours,
  pendingAssigments, canceledAssignments90Days, allAssignments90Days, assignmentsWithUploads }) => {
  if (workspace) {
    return (
      <div className='assignments-page abbreviated-assignments-page'>
        <PendingAssignmentsList
          header='Assignments Pending Acceptance'
          id='unaccepted'
          assignments={unacceptedAssignments}
          maxWeekly={appraiserInfo.maximumWeeklyAssignments ? appraiserInfo.maximumWeeklyAssignments : ''}
          unaccepted />
        <AssignmentsList
          header='Assignments Canceled in the Past 72 Hours'
          id='canceled-72-hours'
          assignments={canceledAssignments72Hours}
          location={location.pathname} />
        <PendingAssignmentsList
          header='Pending and Suspended Assignments'
          id='pending'
          assignments={pendingAssigments}
          maxWeekly={appraiserInfo.maximumWeeklyAssignments ? appraiserInfo.maximumWeeklyAssignments : ''} />
      </div>
    )
  }

  return (
    <div className='assignments-router'>
      <Route exact path='/lgyhub/appraiser/locate-cases' render={() =>
        <ul className='locate-cases-links'>
          <li>
            <LgyLink to='/lgyhub/appraiser/locate-cases/canceled-90-days'>Assignments Canceled in the Past 90 Days</LgyLink>
          </li>
          <li>
            <LgyLink to='/lgyhub/appraiser/locate-cases/all-90-days'>All Assignments in the Past 90 Days</LgyLink>
          </li>
          <li>
            <LgyLink to='/lgyhub/appraiser/locate-cases/with-uploads'>Assignments with Appraisals Uploaded in the Past 30 Days</LgyLink>
          </li>
        </ul>} />
      <Route exact path='/lgyhub/appraiser/locate-cases/canceled-90-days' render={() =>
        <AssignmentsList
          header='Assignments Canceled in the Past 90 Days'
          id='canceled-90-days'
          assignments={canceledAssignments90Days}
          location={location.pathname}
          dispositionDate />} />
      <Route exact path='/lgyhub/appraiser/locate-cases/all-90-days' render={() =>
        <AssignmentsList
          header='All Assignments in the Past 90 Days'
          id='all-90-days'
          assignments={allAssignments90Days}
          location={location.pathname}
          dispositionDate />} />
      <Route exact path='/lgyhub/appraiser/locate-cases/with-uploads' render={() =>
        <AssignmentsList
          header='Assignments with Appraisals Uploaded in the Past 30 Days'
          id='with-uploads'
          assignments={assignmentsWithUploads}
          location={location.pathname}
          dispositionDate />} />
    </div>
  )
}

const mapStateToProps = (state) => ({
  unacceptedAssignments: state.appraiser.workspace.unacceptedAssignments,
  canceledAssignments72Hours: state.appraiser.workspace.canceledAssignments72Hours,
  pendingAssigments: state.appraiser.workspace.pendingAssignments,
  canceledAssignments90Days: state.appraiser.workspace.canceledAssignments90Days,
  allAssignments90Days: state.appraiser.workspace.allAssignments90Days,
  assignmentsWithUploads: state.appraiser.workspace.assignmentsWithUploads30Days
})

export default connect(mapStateToProps)(RenderAssignmentLists)
